import configuration from '../../configuration';
import ODataFulogicsStore from 'fulogics-ui-core/dist/api/odata/ODataFulogicsStore';
import { createModel } from '@rematch/core';
import { iRootModel } from '../iRootModel';
import { DataSourceOptions } from 'devextreme/data/data_source';
import insertToCollectionFunc, {
    insertToCollectionPayload,
} from 'fulogics-ui-core/dist/store/helpers/insertToCollectionFunc';

export const COSOrderReturnStepODataEndpoint = `${configuration.API_BASE_URL}/odata/ReturnSteps/Store`;
export const COSOrderReturnStepStore = ODataFulogicsStore(
    {
        url: COSOrderReturnStepODataEndpoint,
        key: 'id',
        keyType: 'String',
    },
    {
        createByCollectionId: (
            collectionId?: string,
            options?: {
                defaultOrderByPolicy?: 'timetable';
            }
        ) => {
            if (!collectionId) return undefined;

            const customQueryParams = {
                defaultOrderByPolicy: options?.defaultOrderByPolicy,
                collectionId: collectionId?.toString(),
            };

            if (!options?.defaultOrderByPolicy) delete customQueryParams.defaultOrderByPolicy;

            return {
                store: COSOrderReturnStepStore,
                reshapeOnPush: true,
                customQueryParams,
            } as DataSourceOptions;
        },
    }
);

export type COSOrderReturnStepState = {};

export const COSOrderReturnStepModel = createModel<iRootModel>()({
    state: {} as COSOrderReturnStepState,
    //
    effects: (dispatch) => ({
        async setLocation(payload: setLocationPayload) {
            let copyOfPayload = Object.assign({}, payload);
            let modelId = payload.id;
            //
            delete (copyOfPayload as any)['id'];
            //
            await COSOrderReturnStepStore.update(modelId, {
                ...copyOfPayload,
            });
        },
        async setPlannedStartDate(payload: setPlannedStartDatePayload) {
            let copyOfPayload = Object.assign({}, payload);
            let modelId = payload.id;
            //
            delete (copyOfPayload as any)['id'];
            //
            COSOrderReturnStepStore.update(modelId, {
                ...copyOfPayload,
            });
        },
        async insertToCollection<T>(
            payload: insertOrderReturnStepToCollectionPayload & insertToCollectionPayload<T>
        ) {
            return insertToCollectionFunc({
                ...payload,
                //
                url: '/odata/ReturnSteps',
                store: COSOrderReturnStepStore,
            });
        },
        async deleteItem(payload: deleteItemPayload) {
            COSOrderReturnStepStore.remove(payload.itemId);
        },
    }),
    //
    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        dxStore() {
            return COSOrderReturnStepStore;
        },
    }),
});

export default COSOrderReturnStepModel;

export type insertOrderReturnStepToCollectionPayload = {
    collectionId?: string;
};
export type deleteItemPayload = {
    itemId?: string;
};
export type setLocationPayload = {
    id: string;
    location?: {
        logisticUnitId?: number;
        logisticUnit?: any;
        location?: {
            zipCode?: string;
            city?: string;
            street?: string;
            buildingNumber?: string;
            countryId?: number;
            note?: string;
        };
    };
};

export type setPlannedStartDatePayload = {
    id: string;
    plannedStartDate?: Date | null;
};
